export default "__VITE_ASSET__CgrS2POS__"